module.exports = __webpack_public_path__ + "static/media/6.c573d122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Charities/brands/6.jpg
// module id = 597
// module chunks = 0